import React from 'react'
import { useTranslation } from 'react-i18next'

function ItemInfoTable ({ values }) {
  const { t, i18n } = useTranslation()
  return (
    <tbody className='w-full border-collapse border-spacing-0'>
      {values.map((item, index) => (
        <tr key={index}>
          <td
            className={` ${
              i18n.language == 'en' ? 'pr-[12px]' : 'pl-[12px]'
            } text-sm font-normal min-w-[160px] text-gray-500`}
          >
            {item.name}
          </td>
          <td className='!px-0 !py-[3px] text-sm font-medium text-gray-900'>
            {item.value}
          </td>
        </tr>
      ))}
    </tbody>
  )
}

export default ItemInfoTable
